import Cookies from 'js-cookie';
import { Component } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter, HashRouter, Switch, Route } from 'react-router-dom';

import NotFound from 'common/components/layout/404';
import ScrollToTop from 'common/components/routes/ScrollToTop';
import { getRouterType } from 'common/helpers/apiHelper';
import { listClubs } from 'redux/clubs/actions';
import { getCustomer } from 'redux/customer/actions';
import { listReservationTypes } from 'redux/reservationTypes/actions';

import LoggedInRoute from './LoggedInRoute';
import NotLoggedInRoute from './NotLoggedInRoute';
import Account from './account/Account';
import AccountEdit from './account/AccountEdit';
import PasswordEdit from './account/PasswordEdit';
import AddressAdd from './addressBook/Add';
import AddressEdit from './addressBook/Edit';
import AddressList from './addressBook/List';
import ClubEdit from './clubMembership/Edit';
import ClubList from './clubMembership/List';
import ClubShipment from './clubMembership/Shipment';
import CreateAccount from './createAccount/CreateAccount';
import CreditCardAdd from './creditCard/Add';
import CreditCardEdit from './creditCard/Edit';
import CreditCardList from './creditCard/List';
import Dashboard from './dashboard/Dashboard';
import ForgotPassword from './login/ForgotPassword';
import Login from './login/Login';
import Logout from './login/Logout';
import MagicLink from './login/MagicLink';
import MagicLinkActivated from './login/MagicLinkActivated';
import MagicLinkError from './login/MagicLinkError';
import ResetPassword from './login/ResetPassword';
import ResetPasswordError from './login/ResetPasswordError';
import LoyaltyPointList from './loyaltyTransactions/List';
import OrderList from './orderHistory/List';
import OrderView from './orderHistory/View';
import ReservationList from './reservation/List';
import ReservationView from './reservation/View';
import Unsubscribe from './unsubscribe/Unsubscribe';

class ProfileApp extends Component {
  componentDidMount() {
    const { props } = this;
    if (Cookies.get('customerToken')) {
      props.getCustomer();
    }
    props.listClubs();
    props.listReservationTypes();
  }

  render() {
    const router = getRouterType();
    let Router = BrowserRouter;
    if (router === 'hash') {
      Router = HashRouter;
    }
    return (
      <Router>
        <Switch>
          <NotLoggedInRoute exact path="/profile/login" component={Login} />
          <NotLoggedInRoute
            exact
            path="/profile/forgot-password"
            component={ForgotPassword}
          />
          <NotLoggedInRoute
            exact
            path="/profile/magic-link"
            component={MagicLink}
          />
          <Route
            exact
            path="/profile/reset-password/:resetPasswordId"
            component={ResetPassword}
          />
          <NotLoggedInRoute
            exact
            path="/profile/reset-password-link-error"
            component={ResetPasswordError}
          />
          <Route
            exact
            path="/profile/magic-link/:magicLinkId"
            component={MagicLinkActivated}
          />
          <NotLoggedInRoute
            exact
            path="/profile/magic-link-error"
            component={MagicLinkError}
          />
          <Route exact path="/profile/logout" component={Logout} />
          <NotLoggedInRoute
            exact
            path="/profile/create-account"
            component={CreateAccount}
          />
          <LoggedInRoute exact path="/profile" component={Dashboard} />
          <LoggedInRoute exact path="/profile/account" component={Account} />
          <LoggedInRoute
            exact
            path="/profile/account/edit"
            component={AccountEdit}
          />
          <LoggedInRoute
            exact
            path="/profile/account/password"
            component={PasswordEdit}
          />
          <LoggedInRoute
            exact
            path="/profile/order-history"
            component={OrderList}
          />
          <LoggedInRoute
            exact
            path="/profile/order-history/:id"
            component={OrderView}
          />
          <LoggedInRoute
            exact
            path="/profile/reservation"
            component={ReservationList}
          />
          <LoggedInRoute
            exact
            path="/profile/reservation/:id"
            component={ReservationView}
          />
          <LoggedInRoute
            exact
            path="/profile/loyalty-point"
            component={LoyaltyPointList}
          />
          <LoggedInRoute
            exact
            path="/profile/credit-card"
            component={CreditCardList}
          />
          <LoggedInRoute
            exact
            path="/profile/credit-card/add"
            component={CreditCardAdd}
          />
          <LoggedInRoute
            exact
            path="/profile/credit-card/:id"
            component={CreditCardEdit}
          />
          <LoggedInRoute
            exact
            path="/profile/address-book"
            component={AddressList}
          />
          <LoggedInRoute
            exact
            path="/profile/address-book/add"
            component={AddressAdd}
          />
          <LoggedInRoute
            exact
            path="/profile/address-book/:id"
            component={AddressEdit}
          />
          <LoggedInRoute
            exact
            path="/profile/club-membership"
            component={ClubList}
          />
          <LoggedInRoute
            exact
            path="/profile/club-membership/:id"
            component={ClubEdit}
          />
          <LoggedInRoute
            exact
            path="/profile/club-membership/:id/shipment"
            component={ClubShipment}
          />
          <Route exact path="/profile/unsubscribe" component={Unsubscribe} />
          <NotLoggedInRoute component={NotFound} />
        </Switch>
        <ScrollToTop />
      </Router>
    );
  }
}

export default connect(null, {
  getCustomer,
  listClubs,
  listReservationTypes
})(ProfileApp);
